/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ProjetFinancementSearch
 */
export interface ProjetFinancementSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ProjetFinancementSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ProjetFinancementSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ProjetFinancementSearch
     */
    idfinancementType?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ProjetFinancementSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjetFinancementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ProjetFinancementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ProjetFinancementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjetFinancementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ProjetFinancementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ProjetFinancementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ProjetFinancementSearch interface.
 */
export function instanceOfProjetFinancementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProjetFinancementSearchFromJSON(json: any): ProjetFinancementSearch {
    return ProjetFinancementSearchFromJSONTyped(json, false);
}

export function ProjetFinancementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjetFinancementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'idfinancementType': !exists(json, 'idfinancementType') ? undefined : Int32ListSearchFromJSON(json['idfinancementType']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ProjetFinancementSearchToJSON(value?: ProjetFinancementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'code': TextSearchToJSON(value.code),
        'idfinancementType': Int32ListSearchToJSON(value.idfinancementType),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

